import { Icon } from './types';

export const XIcon: Icon = (props) => (
  <svg
    viewBox={'0 0 24 24'}
    aria-hidden={'true'}
    focusable={'false'}
    {...props}
  >
    <path
      d={
        'M13.619 10.768l6.33-7.199h-1.5l-5.498 6.25-4.388-6.25H3.5l6.637 9.451L3.5 20.57H5l5.802-6.601 4.635 6.601H20.5M5.54 4.675h2.304l10.604 14.842h-2.304'
      }
    />
  </svg>
);
